import { PayloadAction } from '@reduxjs/toolkit';
import {
	SubscriptionSate,
	SubscriptionCommunityPartner,
	SubscriptionPlansCommunityPartners
} from 'Types';
import { SubscriptionState } from './SubscriptionSlice';

const reducers = {
	setSubscriptionCommunityPartner(
		state: SubscriptionSate,
		action: PayloadAction<SubscriptionCommunityPartner>
	) {
		const { payload } = action;
		state.selectedCommunityPartner = payload;
	},
	setSubscriptionPlan(
		state: SubscriptionSate,
		action: PayloadAction<SubscriptionPlansCommunityPartners>
	) {
		const { payload } = action;
		state.selectedPlan = payload;
	},
	resetSubscription: () => SubscriptionState
};

export default reducers;
